// extracted by mini-css-extract-plugin
export default {"PageLoader":"E86UVqo4","full":"Vj3GaEHf"};